@defer (when value()) {
  <app-role-form
    [edit]="true"
    [profile]="profile()"
    [access]="access()"
    [(value)]="value"
    [id]="id">
  </app-role-form>
}
